import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import AdCreateForm from '../components/ads/AdCreateForm';
import SocietyContextMobileNav from '../components/societies/SocietyContextMobileNav';
import { adService } from '../services/api';

const AdCreatePage = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const adSlug = params.adSlug || params.id;
  const societySlug = params.societySlug;
  const isEditMode = location.pathname.includes('/edit') && !!adSlug;
  const societyHubNav = societySlug ? (
    <SocietyContextMobileNav societySlug={societySlug} activeSection="ads" />
  ) : null;

  const [initialAd, setInitialAd] = useState(null);
  const [loadingAd, setLoadingAd] = useState(isEditMode);
  const [adLoadError, setAdLoadError] = useState(null);

  useEffect(() => {
    if (!isEditMode) return;
    const loadAd = async () => {
      try {
        setLoadingAd(true);
        setAdLoadError(null);
        const ad = await adService.getAd(adSlug);
        setInitialAd(ad);
      } catch (err) {
        console.error('Error loading ad for edit:', err);
        setAdLoadError('Failed to load ad');
      } finally {
        setLoadingAd(false);
      }
    };
    loadAd();
  }, [isEditMode, adSlug]);

  if (isEditMode && loadingAd) {
    return (
      <PageLayout title="PakPoints">
        <div className="min-h-screen bg-gray-50">
          {societyHubNav}
          <div className="py-8 flex items-center justify-center">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto" />
              <p className="mt-4 text-gray-600">Loading ad...</p>
            </div>
          </div>
        </div>
      </PageLayout>
    );
  }

  if (isEditMode && adLoadError) {
    return (
      <PageLayout title="PakPoints">
        <div className="min-h-screen bg-gray-50">
          {societyHubNav}
          <div className="py-8 flex items-center justify-center">
            <div className="text-center">
              <p className="text-red-600">{adLoadError}</p>
              <button onClick={() => navigate('/ads')} className="mt-4 text-blue-600 hover:underline">Back to Ads</button>
            </div>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout title="PakPoints">
      <Helmet>
        <title>{isEditMode ? 'Edit Ad' : 'Create Ad'} - PakPoints</title>
        <meta name="description" content={isEditMode ? 'Edit your classified ad' : 'Create a new classified ad to sell or buy items on PakPoints'} />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {societyHubNav}
        <div className="py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <AdCreateForm initialAd={initialAd} isEditMode={isEditMode} />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default AdCreatePage;
